<template>
  <div :class="$style.wrapper">
    <l-spectrogram-select
      :data="data"
      :active="stage === 2"
      @error="handleError"
      @success="nextStage"
    />
    <l-popupMessage
      :items="messages"
      :task="task"
      @click="nextStage"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'

import {
  arr1, arr2, hint, task,
} from './arrs'

import { pushPopup, pushHint } from '@/utils/pushPopup'

import pianoSpectrogram from '@/assets/json/bad-guy_piano.json'
import xyloSpectrogram from '@/assets/json/bad-guy_xylo.json'

import gorodXylo from '@/assets/json/imperial-march_piano.json'
import kalinkaPiano from '@/assets/json/no-time-to-die_piano.json'
import kuznechikPiano from '@/assets/json/pink-panther_xylo.json'

const prepareSpect = spect => ({
  ...spect,
  peaks: spect.peaks.map(p => ({ ...p, selected: true })),
})

export default {
  name: 'step2',
  setup(props, { emit }) {
    const stage = ref(0)
    const messages = ref([])

    const data = {
      main: prepareSpect(pianoSpectrogram),
      items: [
        { spectrogram: prepareSpect(xyloSpectrogram), right: true },
        { spectrogram: prepareSpect(gorodXylo), right: false },
        { spectrogram: prepareSpect(kalinkaPiano), right: false },
        { spectrogram: prepareSpect(kuznechikPiano), right: false },
      ],
    }

    const nextStage = () => {
      messages.value = []
      if (stage.value === 0) {
        pushPopup(arr1, messages.value)
      }

      if (stage.value === 2) {
        pushPopup(arr2, messages.value)
      }

      if (stage.value === 3) {
        // root.$router.replace('/education3/lesson3')
        emit('nextStep', 2)
      }

      stage.value += 1
    }

    nextStage()

    const handleError = () => pushHint(hint, messages.value)

    return {
      data,
      stage,
      messages,
      task,
      nextStage,
      handleError,
    }
  },
}
</script>
<style lang="scss" module>
.wrapper {
  background: linear-gradient(180deg, #4F4F4F 0%, #0A001E 100%);
  height: 100%;
  width: 100%;
}
</style>
